import { SelectionStateEnum } from '@monetize/types/app';
import { ReactNode } from 'react';
import { MGrid } from '../Monetize';
import { TransactionApplicationTableSelectRow } from './TransactionApplicationTableSelectRow';

interface TransactionApplicationTableLayoutProps {
  /**
   * CSS grid template describing the columns the header and rows render into.
   */
  gridTemplateColumns: string;
  /**
   * Number of grid cells the "Apply All" label spans (every cell after the
   * checkbox).
   */
  applyAllColSpan: number;
  header: ReactNode;
  checkedState: SelectionStateEnum;
  isDisabled?: boolean;
  onToggleSelectAll: () => void;
  /**
   * The data rows for the table.
   */
  children: ReactNode;
}

/**
 * Presentational grid shell for the transaction application tables. It owns the
 * grid + the "Apply All" select row but knows nothing about which columns are
 * shown — callers compose it with their own header and rows.
 */
export const TransactionApplicationTableLayout = ({
  gridTemplateColumns,
  applyAllColSpan,
  header,
  checkedState,
  isDisabled,
  onToggleSelectAll,
  children,
}: TransactionApplicationTableLayoutProps) => {
  return (
    <MGrid
      role="table"
      gridTemplateColumns={gridTemplateColumns}
      columnGap={4}
      rowGap={4}
      px="4"
    >
      {header}
      <TransactionApplicationTableSelectRow
        checkedState={checkedState}
        isDisabled={isDisabled}
        onToggleSelectAll={onToggleSelectAll}
        applyAllColSpan={applyAllColSpan}
      />
      {children}
    </MGrid>
  );
};
